import Vue from 'vue'
import App from './App.vue'
import '@/assets/tailwind.css'
import '@/assets/custom.css'
import VueScrollTo from 'vue-scrollto'
import VeeValidate from 'vee-validate'

Vue.config.productionTip = false

Vue.use(VeeValidate, {
   classes: true
})

Vue.mixin({
   methods: {
      debounce (func, wait = 100) {
         let timeout
         return function (...args) {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
               func.apply(this, args)
            }, wait)
         }
      }
   }
})

Vue.use(VueScrollTo, {
   easing: 'ease',
   duration: '250'
})

new Vue({
   render: h => h(App)
}).$mount('#app')
